import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16dfddd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "foce-height" }

import { ref, computed } from 'vue';
import {
    AtomInput,
    SearchIcon,
    AtomCheckBox
} from '@/components/atoms';
import { IOptionsSelect } from '@/types';

interface IProps {
    options?: IOptionsSelect[];
    prop?: string;
    model?: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeFilterCheckbox',
  props: {
    options: null,
    prop: null,
    model: null
  },
  emits: ['handleCheckFilter'],
  setup(__props: any, { emit }) {

const props = __props as {
    options?: IOptionsSelect[];
    prop?: string;
    model?: any;
};

const search = ref<string>("");


function handleCheckFilter(prop, value) {
    emit('handleCheckFilter', { prop, value });
}

function isCheckedFilter(prop, value) {
    return (props.model[prop] ?? []).find(f => f == value) != undefined;
}

const computedList = computed(() => {

    return search.value ? props.options?.filter(f => f.text.toLowerCase().includes(search.value.toLowerCase())) : props.options;
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(AtomInput), {
      "append-icon": "",
      prependIcon: "",
      noBgPrependIcon: "",
      noBorderPrependIcon: "",
      placeholder: "Pesquisar",
      modelValue: search.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
      width: "100%",
      classes: "w-100 my-3"
    }, _createSlots({
      prependIcon: _withCtx(() => [
        _createVNode(_unref(SearchIcon))
      ]),
      _: 2
    }, [
      (search.value)
        ? {
            name: "appendIcon",
            fn: _withCtx(() => [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => { search.value = ''}, ["prevent","stop"]))
              }, "X")
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue"]),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(computedList), (option) => {
        return (_openBlock(), _createBlock(_unref(AtomCheckBox), {
          key: String(option.value),
          label: option.text,
          checked: isCheckedFilter(props.prop, option.value),
          onChange: ($event: any) => (handleCheckFilter(props.prop, option.value))
        }, null, 8, ["label", "checked", "onChange"]))
      }), 128))
    ])
  ]))
}
}

})